import React, { useEffect, useState } from 'react';
import styles from './deal.module.css';
import DealCreationSteps from './DealCreationSteps/DealCreationSteps';
import Header from '../../../components/Header/Header';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Button from '../../../components/Button/Button';

import leads from '../../../brand/generated/sidebar/deals.svg';
import DealCreationMainInfo from './DealCreateMainInfo';
import DealCreateEquipment from './DealCreateEquipment';
import DealCreateServices from './DealCreateServices';
import DealCreateDocs from './DealCreateDocs';
import DealCreateOther from './DealCreateOther';
import Alert from '../../../components/Alert/Alert';
import { useNavigate } from 'react-router-dom';
import addItemsToDeal from '../../../api/deals/addItemsToDeal';
import getDealCars from '../../../api/deals/getDealCars';
import formatNumber from '../../../utils/formatNumber';
import { textStyles } from '../../../constants/textStyles';
import addDealComment from '../../../api/deals/addDealComment';
import setStep from '../../../api/deals/setStep';
import LoaderInline from '../../../components/Loader/LoaderInline';
import DealCreateCreditAppeal from './DealCreateCreditAppeal';
import BCCFlow from './BCCFlow';

import {
  BANKS,
  DEAL_STATUS_DOCUMENTS_PROCESSING,
  DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT,
  DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DEAL_STATUS_FILLING_QUESTIONNAIRE,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_POLES,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  DOCUMENT_TYPES_TECH_PASSPORT,
  PAYMENT_STATUS_PAID,
  PAYMENT_TYPES_CREDIT_CARD,
  PAYMENT_TYPES_CREDIT_INVOICE,
  PAYMENT_TYPES_PREPAYMENT_CARD,
  PAYMENT_TYPES_PREPAYMENT_INVOICE,
} from '../../../constants';
import uploadDocumentToDeal from '../../../api/deals/uploadDocumentToDeal';
import createCreditAppeal from '../../../api/creditPlatform/createCreditAppeal';
import DealCreateBanks from './DealCreateBanks';
import DealCreateBanksPay from './DealCreateBanksPay';
import generateUserAgreement from '../../../api/creditPlatform/generateUserAgreement';
import DealCreatePayment from './DealCreatePayment';
import editDeal from '../../../api/deals/editDeal';
import removeItemsToDeal from '../../../api/deals/removeItemsToDeal';
import DealCreateCreditDocuments from './DealCreateCreditDocuments';
import DealCreatePledgeRegistration from './DealCreatePledgeRegistration';
import generateAllowedDocumentsJson from '../../../utils/generateAllowedDocumentsJson';
import getCreditAppeal from '../../../api/deals/getCreditAppeal';
import getCreditAppealSilent from '../../../api/deals/getCreditAppealSilent';
import SendAppealProgress from './SendAppealProgress';
import { resolveAppealState, shouldShowSendProgress } from '../../../utils/appealSubmitState';
import HalykFlow from './HalykFlow';
import FreedomFlow from './FreedomFlow';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import ForteFlow from './ForteFlow';
import ClientPaymentApprove from './ClientPaymentApprove';
import toastAlert from '../../../helpers/alert';
import BerekeFlow from './BerekeFlow';
import ClientRegistrationApprove from './ClientRegistrationApprove';
import AltynFlow from './AltynFlow';
import EurazFlow from './EurazFlow';
import ContractSign from './CommonBankSteps/ContractSign';
import TripartiteContractStep from './CommonBankSteps/TripartiteContractStep/index';
import bankFirstStep, { isConsignmentDeal as carsHaveConsignment, stepAfterBankSelect } from './bankFirstStep';
const DealCreate = ({ deal: savedDeal, cars, equipments, services, update, documents, loading, setLoading }) => {
  const [state, setState] = useState({});
  const [sum, setSum] = useState(0);
  const [currentStep, setCurrentStep] = useState(savedDeal?.step || 1);
  const [succes, setSucces] = useState({});

  const [deal, setDeal] = useState(savedDeal);
  const [orders, setOrders] = useState([]);
  const [usedCar, setUsedCar] = useState(false);
  const [unsavedEquipments, setUnsavedEquipments] = useState([]);
  const [unsavedServices, setUnsavedServices] = useState([]);
  const [agreementModal, setAgreementModal] = useState(false);
  const [chosenBankId, setChosenBankId] = useState(null);
  const [chosenBankAppealId, setChosenBankAppealId] = useState(null);
  const [chosenBankAppeal, setChosenBankAppeal] = useState(null);
  const [creditAppeals, setCreditAppeals] = useState([]);

  const isCreditDeal =
    deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_CARD || deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_INVOICE;

  const isConsignmentDeal = carsHaveConsignment(cars);

  useEffect(() => {
    let cancelled = false;
    if (savedDeal?.id) {
      getDealCars({ id: savedDeal?.id }).then((res) => {
        const options = res?.data?.cars?.map((item) => {
          return {
            label: `${item.mark} ${item.model} (VIN ${item?.vin}, ${item?.complectation?.title}, ${
              item?.complectation?.engine?.title
            }, ${formatNumber(item?.container?.toPrice)} â¸)`,
            value: item?.orderId,
          };
        });

        setOrders(options);
        // ÐÐ£-Ð°Ð²ÑÐ¾ (Ð²ÑÐºÑÐ¿, Ð¼ÐµÐ½Ð°, Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ) â Ð·Ð°ÑÐ²ÐºÐ¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð² Ð±Ð°Ð½ÐºÐ¸ Ð¸Ð· USED_CAR_BANK_IDS.
        setUsedCar((res?.data?.cars || []).some((item) => item?.used === true));
      });

      getCreditAppeal({ chunkId: savedDeal?.chunkId }).then((res) => {
        if (cancelled) return;
        const appeals = res?.data?.appeals || [];
        const chosenBank = appeals.find((appeal) => appeal?.selected) || (appeals.length === 1 ? appeals[0] : null);
        const fromAppeal = chosenBank?.bank?.id || chosenBank?.bankId;
        const onlyDealBank = savedDeal?.bankIds?.length === 1 ? savedDeal.bankIds[0] : null;
        // ÐÐ°ÑÐ²ÐºÐ¸ ÑÐ¾ÑÑÐ°Ð½ÑÐµÐ¼ Ð²ÑÐµÐ³Ð´Ð°: Ð¸Ð· Ð½Ð¸Ñ Ð¿ÑÐ°Ð²Ð°Ñ Ð¿Ð°Ð½ÐµÐ»Ñ Ð±ÐµÑÑÑ Ð´Ð°ÑÑ Ð¿Ð¾Ð´Ð°ÑÐ¸, ÑÑÐ±ÑÐ¸Ð´Ð¸Ñ
        // Ð¸ ÑÐµÐ¼ÐµÐ¹Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ. Ð Ð°Ð½ÑÑÐµ Ð²ÑÑÐ¾Ð´ Ð¿Ð¾ Ð¾ÑÑÑÑÑÑÐ²Ð¸Ñ Ð±Ð°Ð½ÐºÐ° ÑÑÐ¾ÑÐ» Ð²ÑÑÐµ â Ð¸ Ð¿Ð¾ÐºÐ°
        // ÐºÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð» Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, ÑÑÐ¸ Ð¿Ð¾Ð»Ñ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ð¿ÑÐ¾ÑÑÐ¾ Ð¿ÑÐ¾Ð¿Ð°Ð´Ð°Ð»Ð¸.
        setCreditAppeals(appeals);

        const bankId = fromAppeal || onlyDealBank;
        if (!bankId) return;
        setChosenBankId(bankId);
        if (chosenBank) {
          setChosenBankAppealId(chosenBank.id);
          setChosenBankAppeal(chosenBank);
        }
      });
    }
    setDeal(savedDeal);
    return () => {
      cancelled = true;
    };
  }, [savedDeal]);

  const onSubmitStep1 = () => {
    update && update();
  };
  const onEquipmentSubmit = (equipments, orderId) => {
    setLoading(true);
    addItemsToDeal({
      cars: [{ orderId: String(orderId), value: String(orderId) }],
      dealId: String(deal?.id),
      equipments,
      step: 3,
    })
      .then(() => {
        setUnsavedEquipments([]);
        update();
        setCurrentStep(3);
      })
      .catch((err) => alert(err))
      .finally(() => setLoading(false));
  };
  const onSubmitStep3 = (services, orderId, step = 4) => {
    setLoading(true);
    addItemsToDeal({
      cars: [{ orderId: String(orderId), value: String(orderId) }],
      dealId: String(savedDeal?.id),
      services,
    })
      .then(async () => {
        setUnsavedServices([]);
        // ÐÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ°: ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¹ ÑÐ°Ð³ â Ð¾Ð¿Ð»Ð°ÑÐ°. ÐÑÐµÐ´Ð¸Ñ: ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¹ ÑÐ°Ð³ â Ð°Ð½ÐºÐµÑÐ°,
        // Â«ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¾Ð¿Ð»Ð°ÑÑÂ» ÑÐ°Ð¼ Ð²Ð²Ð¾Ð´Ð¸Ð» Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ¾Ð² Ð² Ð·Ð°Ð±Ð»ÑÐ¶Ð´ÐµÐ½Ð¸Ðµ.
        const isCredit =
          savedDeal?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE ||
          savedDeal?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD;
        await editDeal({
          dealId: savedDeal?.id,
          id: savedDeal?.id,
          statusId: isCredit ? DEAL_STATUS_FILLING_QUESTIONNAIRE : DEAL_STATUS_WAITING_FOR_PAYMENT,
          paymentTypeId: savedDeal?.paymentType?.id,
          equipmentStepPassed: true,
          ...generateAllowedDocumentsJson(
            savedDeal?.paymentType?.id == PAYMENT_TYPES_PREPAYMENT_INVOICE
              ? [DOCUMENT_TYPES_INVOICE]
              : [DOCUMENT_TYPES_TECH_PASSPORT]
          ),
        });
        setStep({ dealId: savedDeal?.id, step }).then(() => {
          update();
        });
      })
      .catch((err) => alert(err))
      .finally(() => setLoading(false));
  };
  const onSubmitStep4 = () => {
    update();
  };

  const [sendFormLoading, setSendFormLoading] = useState(false);
  // ÐÑÐ¾Ð³ÑÐµÑÑ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸: ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð±Ð°Ð½ÐºÐ¾Ð² ÑÐ¶Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¾ Ð¸ ÑÑÐ¾ Ñ ÐºÐ°Ð¶Ð´ÑÐ¼.
  const [sendProgress, setSendProgress] = useState(null);
  const [sendProgressError, setSendProgressError] = useState(null);
  const sendPollRef = React.useRef(null);
  const lastSubmitRef = React.useRef(null);

  React.useEffect(() => () => clearTimeout(sendPollRef.current), []);

  // ÐÐ°ÑÐ²ÐºÐ¸ ÑÐµÐºÑÑÐµÐ¹ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð¾ÑÐ»Ð¸ÑÐ°ÐµÐ¼ Ð¿Ð¾ id: Ð²ÑÑ, ÑÑÐ¾ Ð±Ð¾Ð»ÑÑÐµ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾
  // ÑÑÑÐµÑÑÐ²ÑÑÑÐµÐ³Ð¾ Ð½Ð° Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð½Ð°Ð¶Ð°ÑÐ¸Ñ. ÐÐ¾ Ð²ÑÐµÐ¼ÐµÐ½Ð¸ Ð½ÐµÐ»ÑÐ·Ñ â createdAt Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ
  // Ð² UTC, Ð° ÑÐ°ÑÑ Ð±ÑÐ°ÑÐ·ÐµÑÐ° Ð¶Ð¸Ð²ÑÑ Ð² ÑÐ²Ð¾ÐµÐ¹ Ð·Ð¾Ð½Ðµ.
  const readAppeals = (chunkId) =>
    getCreditAppealSilent({ chunkId })
      .then((res) => res?.data?.appeals || [])
      .catch(() => null);

  const stopSendPolling = () => {
    clearTimeout(sendPollRef.current);
    sendPollRef.current = null;
  };

  // ÐÐºÐ½Ð¾ Ð¿ÑÐ¾Ð³ÑÐµÑÑÐ° Ð¿Ð¾Ð´Ð½Ð¸Ð¼Ð°ÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð³Ð´Ð° Ð·Ð°ÑÐ²ÐºÐ¸ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð¿Ð¾ÑÐ²Ð¸Ð»Ð¸ÑÑ. ÐÐ° Ð¿ÐµÑÐ²Ð¾Ð¼
  // ÐºÐ»Ð¸ÐºÐµ Ð¸Ñ ÐµÑÑ Ð½ÐµÑ: Ð±ÑÐºÐµÐ½Ð´ Ð¾ÑÐ²ÐµÑÐ°ÐµÑ Â«ÐÐ¢Ð Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Â», Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¸Ð´ÑÑ
  // Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ. ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð² ÑÑÐ¾Ñ Ð¼Ð¾Ð¼ÐµÐ½Ñ Â«Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð² Ð±Ð°Ð½ÐºÐ¸Â»
  // â Ð²ÑÐ°ÑÑ.
  const startSendPolling = (chunkId, baselineId, total) => {
    stopSendPolling();
    // ÐÐµÑÐ²ÑÐ¹ Ð¾Ð¿ÑÐ¾Ñ Ð´ÐµÐ»Ð°ÐµÐ¼ Ð±ÑÑÑÑÑÐ¼: Ð·Ð°ÑÐ²ÐºÐ¸ ÑÐ¾Ð·Ð´Ð°ÑÑÑÑ Ð² Ð±Ð°Ð·Ðµ Ð² Ð¿ÐµÑÐ²ÑÑ Ð¶Ðµ ÑÐµÐºÑÐ½Ð´Ñ,
    // Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ²Ð¸Ð´ÐµÑÑ Ð¾ÐºÐ½Ð¾ ÑÑÐ°Ð·Ñ, Ð° Ð½Ðµ ÑÐµÑÐµÐ· Ð¿Ð¾Ð»ÑÐ¾ÑÑ ÑÐµÐºÑÐ½Ð´Ñ Ð¿ÑÑÑÐ¾Ð³Ð¾
    // ÑÐºÑÐ°Ð½Ð°. ÐÐ°Ð»ÑÑÐµ Ð¾Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ ÑÐµÐ¶Ðµ â Ð¾ÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¸Ð´ÑÑ ÑÐµÐºÑÐ½Ð´Ð°Ð¼Ð¸.
    let delay = 300;

    const tick = async () => {
      const appeals = await readAppeals(chunkId);
      const fresh = (appeals || []).filter((appeal) => appeal?.id > baselineId);
      if (fresh.length > 0) {
        setSendProgress({
          total: Math.max(total, fresh.length),
          banks: fresh
            .sort((a, b) => a.id - b.id)
            .map((appeal) => ({
              id: appeal.id,
              name: appeal?.bank?.name || `ÐÐ°Ð½Ðº ${appeal?.bankId}`,
              state: resolveAppealState(appeal),
            })),
        });
      }
      if (sendPollRef.current === null) return;
      sendPollRef.current = setTimeout(tick, delay);
      delay = 1200;
    };

    sendPollRef.current = setTimeout(tick, delay);
    delay = 1200;
  };

  const handleCreateCreditSubmit = async (values, documents, files, showError = false) => {
    lastSubmitRef.current = { values, documents, files, showError };
    const chunkId = deal?.chunkId;
    const total = values?.bankIds?.length || 0;

    try {
      documents.map((doc) => uploadDocumentToDeal(doc));
      setSendFormLoading(true);
      setSendProgressError(null);
      setSendProgress(null);
      // ÐÐºÐ½Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ ÑÐ²Ð¾Ñ Ð¾ÑÑÐ°Ð±Ð¾ÑÐ°Ð»Ð¾ â Ð·Ð°ÐºÑÑÐ²Ð°ÐµÐ¼ ÑÑÐ°Ð·Ñ, Ð° Ð½Ðµ ÐºÐ¾Ð³Ð´Ð°
      // Ð¿ÑÐ¸Ð´ÑÑ Ð¿ÐµÑÐ²ÑÐµ Ð¾ÑÐ²ÐµÑÑ: Ð¸Ð½Ð°ÑÐµ Ð¾Ð½Ð¾ ÐµÑÑ Ð¿Ð°ÑÑ ÑÐµÐºÑÐ½Ð´ Ð²Ð¸ÑÐ¸Ñ ÑÐ²ÐµÑÑÑ Ð¿ÑÑÑÑÐ¼
      // ÑÐµÑÑÐ¼ Ð¿ÑÑÐ¼Ð¾ÑÐ³Ð¾Ð»ÑÐ½Ð¸ÐºÐ¾Ð¼ ÑÐ¾ ÑÐ¿Ð¸Ð½Ð½ÐµÑÐ¾Ð¼. ÐÑÐ»Ð¸ Ð¾ÐºÐ°Ð¶ÐµÑÑÑ, ÑÑÐ¾ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð²ÑÑ-ÑÐ°ÐºÐ¸
      // Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¾, Ð±ÑÐºÐµÐ½Ð´ Ð¾ÑÐ²ÐµÑÐ¸Ñ Â«ÐÐ¢Ð Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Â» Ð¸ Ð¾ÐºÐ½Ð¾ Ð¾ÑÐºÑÐ¾ÐµÑÑÑ ÑÐ½Ð¾Ð²Ð°.
      setAgreementModal(false);

      const before = chunkId ? await readAppeals(chunkId) : [];
      const baselineId = (before || []).reduce((max, i) => Math.max(max, i?.id || 0), 0);
      if (chunkId) startSendPolling(chunkId, baselineId, total);

      return createCreditAppeal(
        {
          ...values,
          MaritalStatus: values?.MaritalStatus?.value,
        },
        files
      )
        // ÐÐ¾Ð·Ð²ÑÐ°ÑÐ°ÐµÐ¼ { sent }, ÑÑÐ¾Ð±Ñ Ð°Ð½ÐºÐµÑÐ° Ð·Ð½Ð°Ð»Ð°, ÑÑÐ¾Ð´Ð¸Ð»Ð° Ð»Ð¸ Ð·Ð°ÑÐ²ÐºÐ° Ð½Ð° ÑÐ°Ð¼Ð¾Ð¼
        // Ð´ÐµÐ»Ðµ. Ð§ÐµÑÐ½Ð¾Ð²Ð¸Ðº ÑÐ¾ÑÐ¼Ñ Ð¼Ð¾Ð¶Ð½Ð¾ ÑÑÐ¸ÑÐ°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ ÑÐµÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸:
        // Ð½Ð° Ð¿ÐµÑÐ²Ð¾Ð¼ ÐºÐ»Ð¸ÐºÐµ Ð±Ð°Ð½Ðº ÐµÑÑ Ð¶Ð´ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ, Ð¸ Ð¾Ð±Ð½ÑÐ»ÑÑÑ
        // Ð²Ð²ÐµÐ´ÑÐ½Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ ÑÑÑ Ð½ÐµÐ»ÑÐ·Ñ.
        .then(() => {
          stopSendPolling();
          setSendProgress(null);
          setStep({ dealId: deal?.id, step: 5 }).then(() => {
            update();
          });
          return { sent: true };
        })
        .catch(async (err) => {
          stopSendPolling();
          if (err?.response?.data?.error == 'ÐÐ¢Ð Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½') {
            setSendProgress(null);
            setAgreementModal(true);
            return { sent: false };
          }
          // ÐÑÐ²ÐµÑ Ð´Ð¾ Ð½Ð°Ñ Ð½Ðµ Ð´Ð¾ÑÑÐ» â Ð½Ð¾ Ð·Ð°ÑÐ²ÐºÐ¸ Ð¼Ð¾Ð³Ð»Ð¸ ÑÐ¹ÑÐ¸. Ð¨Ð°Ð³ ÑÐ´ÐµÐ»ÐºÐ¸ ÑÐµÐ¿ÐµÑÑ
          // ÑÑÐ°Ð²Ð¸Ñ Ð±ÑÐºÐµÐ½Ð´, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÐ¾ÑÑÐ¾ Ð¿ÑÐ¾Ð²ÐµÑÑÐµÐ¼, Ð¿Ð¾ÑÐ²Ð¸Ð»Ð¸ÑÑ Ð»Ð¸ Ð·Ð°ÑÐ²ÐºÐ¸, Ð¸
          // Ð½Ðµ Ð·Ð°ÑÑÐ°Ð²Ð»ÑÐµÐ¼ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¿ÐµÑÐµÐºÐ¸Ð´ÑÐ²Ð°ÑÑ ÑÐ´ÐµÐ»ÐºÑ ÑÑÐºÐ°Ð¼Ð¸.
          const after = chunkId ? await readAppeals(chunkId) : null;
          const created = (after || []).filter((appeal) => appeal?.id > baselineId);
          if (created.length > 0) {
            setSendProgress(null);
            update();
            return { sent: true };
          }
          setSendProgressError(
            extractErrorMessage(err) ||
              'ÐÐ°ÑÐ²ÐºÐ° Ð½Ðµ ÑÑÐ»Ð° Ð² Ð±Ð°Ð½ÐºÐ¸. ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÐ²ÑÐ·Ñ Ð¸ Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐµÑÑ ÑÐ°Ð·.'
          );
          return { sent: false };
        })
        .finally(() => {
          setSendFormLoading(false);
        });
    } catch (e) {
      console.log(e);
      stopSendPolling();
      setSendFormLoading(false);
      setSendProgressError('ÐÐ°ÑÐ²ÐºÐ° Ð½Ðµ ÑÑÐ»Ð° Ð² Ð±Ð°Ð½ÐºÐ¸. ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐµÑÑ ÑÐ°Ð·.');
    }
  };

  const onSubmitStep5 = (values) => {
    addDealComment({
      managerId: String(values?.managerId?.value),
      dealId: String(savedDeal?.id),
      comment: values?.comment,
    }).then(() => {
      setStep({ dealId: savedDeal?.id, step: 10 }).then(() => {
        update();
      });
    });
  };

  const onBankSelect = (bankId, appeal) => {
    console.log('BANKID', bankId);
    setChosenBankId(bankId);
    setChosenBankAppeal(appeal || null);
    setChosenBankAppealId(appeal?.id ?? null);
    // ÐÐ²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ: Ð¼ÐµÐ¶Ð´Ñ Ð²ÑÐ±Ð¾ÑÐ¾Ð¼ Ð±Ð°Ð½ÐºÐ° Ð¸ ÐÐÐ Ð²ÐºÐ»Ð¸Ð½Ð¸Ð²Ð°ÐµÑÑÑ
    // Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹ ÑÐ°Ð³ Ñ ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¼ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ¾Ð¼, Ð´Ð°Ð»ÑÑÐµ Ð¿Ð¾ÑÐ¾Ðº Ð±Ð°Ð½ÐºÐ° Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°ÐµÑÑÑ.
    const nextStep = stepAfterBankSelect(bankId, appeal, cars);
    //check bank id and move to the flow of this bank
    if (bankId === BANKS.HALYK) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.FREEDOM) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.FORTE) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }

    if (bankId === BANKS.BEREKE) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.BCK) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.ALTYN) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }
    if (bankId === BANKS.EURAZ) {
      return editDeal({
        dealId: savedDeal?.id,
        id: savedDeal?.id,
        ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER]),
      }).then(() => {
        setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
          update();
        });
      });
    }

    editDeal({
      dealId: savedDeal?.id,
      id: savedDeal?.id,
      statusId: DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT,
      ...generateAllowedDocumentsJson([DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT, DOCUMENT_TYPES_GUARANTEE_LETTER]),
    }).then(() => {
      setStep({ dealId: savedDeal?.id, step: nextStep }).then(() => {
        update();
      });
    });
  };

  const dealComplete = () => {
    setStep({ dealId: savedDeal?.id, step: 10 }).then(() => {
      update();
    });
  };

  const onClientPaymentApproveSubmit = async () => {
    setLoading(true);
    try {
      let newStep = 6;

      if (chosenBankId === BANKS.HALYK) {
        newStep = DEAL_STEPS.HALYK.NOTARIAL_VERIFICATION;
      }
      if (chosenBankId === BANKS.FREEDOM) {
        newStep = DEAL_STEPS.FREEDOM.AUTO_REGISTRATION;
      }
      if (chosenBankId === BANKS.BCK) {
        newStep = DEAL_STEPS.BCK.NOTARIAL_VERIFICATION;
      }
      if (chosenBankId === BANKS.FORTE) {
        newStep = DEAL_STEPS.FORTE.NOTARIAL_VERIFICATION;
      }

      await editDeal({
        id: deal?.id,
        statusPaymentId: PAYMENT_STATUS_PAID,
        statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
        ]),
      });
      await setStep({ dealId: savedDeal?.id, step: newStep });
      update();
    } catch (e) {
      toastAlert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸');
    }
  };
  const onClientRegistrationApproveSubmit = async () => {
    setLoading(true);
    try {
      let newStep = 6;

      if (chosenBankId === BANKS.HALYK) {
        newStep = DEAL_STEPS.HALYK.CAR_DELIVERY;
      }
      if (chosenBankId === BANKS.FREEDOM) {
        newStep = DEAL_STEPS.FREEDOM.WAITING_FOR_FINAL_ACTIONS;
      }
      if (chosenBankId === BANKS.BCK) {
        newStep = DEAL_STEPS.BCK.CAR_DELIVERY;
      }
      if (chosenBankId === BANKS.FORTE) {
        newStep = DEAL_STEPS.FORTE.WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_MOBILE_APP;
      }

      await editDeal({
        id: deal?.id,
        statusPaymentId: PAYMENT_STATUS_PAID,
        statusId: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
        ]),
      });
      await setStep({ dealId: savedDeal?.id, step: newStep });
      update();
    } catch (e) {
      toastAlert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸');
    }
  };

  const backHandler = (e, step) => {
    e.preventDefault();
    // setCurrentStep(currentStep - 1);
    setStep({ dealId: deal?.id, step: step || currentStep - 1 }).then(() => {
      update && update();
    });
  };

  const removeEquipment = (id) => {
    setLoading(true);
    removeItemsToDeal({
      equipments: [{ value: id }],
      dealId: deal?.id,
    })
      .then(() => {
        update();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const removeService = (id) => {
    setLoading(true);
    removeItemsToDeal({
      services: [{ value: id }],
      dealId: deal?.id,
    })
      .then(() => {
        update();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // ÐµÑÐ»Ð¸ Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐµ ÑÐ¶Ðµ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð»Ð°ÑÑ Ð·Ð°ÑÐ²ÐºÐ° Ð² Ð±Ð°Ð½Ðº â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐµÐ½Ñ Ð¸Ð· Ð½ÐµÑ
    // (Ð·Ð°Ð¼Ð¾ÑÐ¾Ð¶ÐµÐ½Ð½ÑÑ Ð½Ð° Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¿Ð¾Ð´Ð°ÑÐ¸), Ð° Ð½Ðµ ÑÐµÐºÑÑÐ¸Ð¹ Ð¿ÐµÑÐµÑÑÑÑ Ð¿Ð¾ ÑÐ¾ÑÑÐ°Ð²Ñ Ð·Ð°ÐºÐ°Ð·Ð°,
    // ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð¼Ð¾Ð¶ÐµÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾Ð´Ð°ÑÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸
    const sum = savedDeal?.creditAppeal?.fullPrice ?? savedDeal?.sum ?? 0;
    const sum2 =
      unsavedEquipments?.reduce((acc, item) => {
        return acc + item?.price * item?.n;
      }, 0) || 0;
    const sum3 =
      unsavedServices?.reduce((acc, item) => {
        return acc + item?.price;
      }, 0) || 0;
    setSum(sum + sum2 + sum3);
  }, [savedDeal, cars, equipments, unsavedEquipments, unsavedServices]);

  useEffect(() => {
    setCurrentStep(savedDeal?.step || 1);
  }, [savedDeal]);

  const updateCurrentStep = (step) => {
    setStep({ dealId: savedDeal?.id, step }).then(() => {
      update();
    });
  };

  const back = (step) => {
    return (
      <Button
        text={'ÐÐ°Ð·Ð°Ð´'}
        disabled={loading}
        onClick={(e) => backHandler(e, step)}
        style={{ color: '#BABABA', border: '1px solid #BABABA', width: '140px' }}
      />
    );
  };

  return (
    <>
      <Header title={'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°'} icon={leads} />
      <Breadcrumbs navigate={'/deals'} link={'Ð¡Ð´ÐµÐ»ÐºÐ¸'} currentPage={'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°'} />
      <SendAppealProgress
        open={shouldShowSendProgress({
          loading: sendFormLoading,
          banks: sendProgress?.banks,
          error: sendProgressError,
        })}
        total={sendProgress?.total || 0}
        banks={sendProgress?.banks || []}
        error={sendProgressError}
        onRetry={() => {
          const last = lastSubmitRef.current;
          setSendProgressError(null);
          if (last) handleCreateCreditSubmit(last.values, last.documents, last.files, last.showError);
        }}
        onClose={() => {
          setSendProgressError(null);
          setSendProgress(null);
        }}
      />
      <div className={styles.DealCreate}>
        <div className={styles.DealCreateForm} id="DealCreateForm">
          {loading ? (
            <LoaderInline />
          ) : (
            <>
              {currentStep === 1 && (
                <DealCreationMainInfo nextStep={onSubmitStep1} deal={deal} cars={cars} update={update} />
              )}
              {currentStep === 2 && (
                <DealCreateEquipment
                  deal={deal}
                  equipments={equipments}
                  setUnsavedEquipments={setUnsavedEquipments}
                  orders={orders}
                  onSubmit={onEquipmentSubmit}
                  update={update}
                  dealCars={cars}
                  backHandler={back}
                />
              )}
              {(currentStep === 3 || currentStep === 311) && (
                <DealCreateServices
                  onSubmit={(services, orderId) => {
                    // onSubmitStep3(services, orderId, currentStep === 3 ? 311 : 4)
                    onSubmitStep3(services, orderId, 4);
                  }}
                  paymentType={savedDeal?.paymentType?.id}
                  deal={deal}
                  services={services}
                  orders={orders}
                  update={update}
                  setUnsavedServices={setUnsavedServices}
                  setLoading={setLoading}
                  backHandler={() => back(currentStep === 311 ? 3 : null)}
                  dealCars={cars}
                  enableInsurance={currentStep === 311}
                />
              )}
              {currentStep === 4 && !isCreditDeal && (
                <DealCreatePayment
                  onSubmit={onSubmitStep4}
                  deal={deal}
                  documents={documents}
                  update={update}
                  backHandler={() => back(311)}
                  cars={cars}
                />
              )}
              {currentStep === 4 && isCreditDeal && (
                <DealCreateCreditAppeal
                  onSubmit={handleCreateCreditSubmit}
                  deal={deal}
                  documents={documents}
                  orders={orders}
                  agreementModal={agreementModal}
                  setAgreementModal={setAgreementModal}
                  backHandler={() => back(311)}
                  sendFormLoading={sendFormLoading}
                  creditAppeals={creditAppeals}
                  usedCar={usedCar}
                />
              )}

              {currentStep === 5 && !isCreditDeal && (
                <DealCreateDocs
                  onSubmit={onSubmitStep4}
                  deal={deal}
                  documents={documents}
                  update={update}
                  backHandler={back}
                  cars={cars}
                />
              )}
              {currentStep === 6 && !isCreditDeal && (
                <DealCreateOther
                  onSubmit={onSubmitStep5}
                  deal={deal}
                  update={update}
                  documents={documents}
                  backHandler={back}
                  cars={cars}
                />
              )}
              {currentStep === 5 && isCreditDeal && (
                <DealCreateBanks
                  deal={deal}
                  onSubmit={onBankSelect}
                  backHandler={back}
                  services={services}
                  update={update}
                  documents={documents}
                  orders={orders}
                />
              )}
              {/* {currentStep === 6 && isCreditDeal && (
                <DealCreateBanksPay deal={deal} onSubmit={dealComplete} documents={documents} backHandler={back} />
              )} */}
              {/* Ð¨Ð°Ð³Ð¸ 4 Ð¸ 5 â Ð¾Ð±ÑÐ¸Ðµ: Ñ ÐºÑÐµÐ´Ð¸ÑÐ° ÑÑÐ¾ Â«ÐÐ°Ð½ÐºÂ» Ð¸ Ð¿Ð¾ÑÐ¾Ðº Ð±Ð°Ð½ÐºÐ°, Ñ Ð½Ð°Ð»Ð¸ÑÐ½ÑÑ
                  Â«ÐÐ¿Ð»Ð°ÑÐ°Â» Ð¸ ÐÐÐ (DealCreateDocs). ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð²ÑÑÐ°ÑÑ Ð¼ÐµÐ¶Ð´Ñ Ð½Ð¸Ð¼Ð¸. */}
              {currentStep === DEAL_STEPS.TRIPARTITE_CONTRACT && (
                <TripartiteContractStep
                  deal={deal}
                  prevStep={isCreditDeal ? 5 : 4}
                  nextStep={isCreditDeal ? (chosenBankId ? bankFirstStep(chosenBankId, chosenBankAppeal) : null) : 5}
                  update={update}
                />
              )}
              {currentStep == DEAL_STEPS.SIGN_CONTRACT && (
                <ContractSign
                  deal={deal}
                  documents={documents}
                  cars={cars}
                  dealStepAfterSign={DEAL_STEPS.NOTARIAL_DOCUMENTS}
                  setLoading={setLoading}
                  update={update}
                />
              )}
              {currentStep === 6 && isCreditDeal && (
                <DealCreateCreditDocuments
                  deal={deal}
                  update={update}
                  onSubmit={dealComplete}
                  documents={documents}
                  backHandler={back}
                  chosenBankAppealId={chosenBankAppealId}
                />
              )}
              {currentStep === 7 && isCreditDeal && (
                <DealCreatePledgeRegistration
                  deal={deal}
                  update={update}
                  onSubmit={dealComplete}
                  documents={documents}
                  backHandler={back}
                />
              )}
              {chosenBankId && currentStep === DEAL_STEPS.CLIENT_PAYMENT_APPROVE && (
                <ClientPaymentApprove onSubmit={onClientPaymentApproveSubmit} />
              )}
              {chosenBankId && currentStep === DEAL_STEPS.CLIENT_REGISTRATION_APPROVE && (
                <ClientRegistrationApprove onSubmit={onClientRegistrationApproveSubmit} />
              )}
              {chosenBankId === BANKS.HALYK && (
                <HalykFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  cars={cars}
                  chosenBankAppealId={chosenBankAppealId}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.ALTYN && (
                <AltynFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  cars={cars}
                  chosenBankAppealId={chosenBankAppealId}
                  bankId={chosenBankId}
                  setLoading={setLoading}
                />
              )}
              {chosenBankId === BANKS.FREEDOM && (
                <FreedomFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  chosenBankAppeal={chosenBankAppeal}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.FORTE && (
                <ForteFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.BEREKE && (
                <BerekeFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.BCK && (
                <BCCFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                />
              )}
              {chosenBankId === BANKS.EURAZ && (
                <EurazFlow
                  deal={deal}
                  documents={documents}
                  step={currentStep}
                  backHandler={back}
                  update={update}
                  chosenBankAppealId={chosenBankAppealId}
                  cars={cars}
                  bankId={chosenBankId}
                  chosenBankAppeal={chosenBankAppeal}
                />
              )}
            </>
          )}
        </div>
        <DealCreationSteps
          currentStep={currentStep}
          setCurrentStep={updateCurrentStep}
          state={state}
          sum={sum}
          deal={savedDeal}
          equipments={equipments}
          services={services}
          cars={cars}
          removeEquipment={removeEquipment}
          removeService={removeService}
          documents={documents}
          chosenBankId={chosenBankId}
          update={update}
          chosenBankAppealId={chosenBankAppealId}
          chosenBankAppeal={chosenBankAppeal}
          creditAppeals={creditAppeals}
        />
      </div>

      {succes.message && <Alert message={succes.message} onClick={setSucces} />}
    </>
  );
};

export default DealCreate;
